import { onboardingHelper } from './onboardingHelper'
import EventBus from '@/event-bus'

export function schoolDashboardHelper() {
    return {
        steps: [
            {
                element: '#school-option',
                intro: `${ onboardingHelper().closeIconText('doneAdminSchoolDashOnboarding') }
                    <h2>SCHOOL DASHBOARD</h2>
                    <p>We recently created a tool to help you and your staff better plan for <i>Advance</i> observations. You can find it under the School tab here.</p>
                    <p>Would you like to explore the new Caseload Management featured right now?</p>`,
                tooltipClass: 'hide-skip caseload-highlighter',
                disableInteraction: true
            },
            {
                element: '.viewby-container',
                intro: `${ onboardingHelper().closeIconText('doneAdminSchoolDashOnboarding') }
                    <h2>SCHOOL DASHBOARD</h2>
                    <p>Use the school dashboard to view observations by average component score. By clicking "Count", the school dashboard changes to show the number of observations per component.</p>
                    <p>This can help you make decisions about who to observe and what to focus on when sharing feedback with a teacher. Try it now!</p>`,
                tooltipClass: 'hide-skip'
            },
            {
                element: '.admin.headers',
                intro: `${ onboardingHelper().closeIconText('doneAdminSchoolDashOnboarding') }
                    <h2>SCHOOL DASHBOARD</h2>
                    <p>You can click a column title to sort ratings by highest or lowest for a component.</p>
                    <p>This can show you where teacher performance is strong or needs improvement. Try it now!</p>`,
                tooltipClass: 'hide-skip'
            },
            {
                element: '#comp-average',
                intro: `${ onboardingHelper().closeIconText('doneAdminSchoolDashOnboarding') }
                    <h2>SCHOOL DASHBOARD</h2>
                    <p>You can click into a score to view notes on the rationale behind each average rating by component.</p>
                    <p>This can help you get a quick snapshot on what feedback a teacher has received so far. Try it now!</p>`,
                tooltipClass: 'hide-skip'
            },
            {
                element: '#school-dash-filters',
                intro: `${ onboardingHelper().closeIconText('doneAdminSchoolDashOnboarding') }
                    <h2>SCHOOL DASHBOARD</h2>
                    <p>You can use the filters to select a combination of evaluator, grades, subject, and year to narrow the focus of the data.</p>
                    <p>Use this feature to help guide discussion in upcoming departmental meetings. Try it now!</p>`,
                tooltipClass: 'hide-skip'
            },
            {
                element: '.school-filter',
                intro: `${ onboardingHelper().closeIconText('doneAdminSchoolDashOnboarding') }
                    <h2>SCHOOL DASHBOARD</h2>
                    <p>You can switch school views by typing or selecting a school from the dropdown.</p>
                    <p>With this feature, you can quickly check in on multiple schools. Try it now!</p>`,
                tooltipClass: 'hide-skip'
            },
            {
                element: '.school-level-components',
                intro: `${ onboardingHelper().closeIconText('doneAdminSchoolDashOnboarding') }
                    <h2>SCHOOL DASHBOARD</h2>
                    <p>The stacked bar chart reflects the filters you have selected above.</p>
                    <p>You can use this tool to get an at-a-glance view of your school's strengths and areas of growth by component.</p>`,
                tooltipClass: 'hide-skip',
                position: 'right'
            },
            {
                element: '#teacher-step',
                intro: `${ onboardingHelper().closeIconText('doneAdminSchoolDashOnboarding') }
                    <h2>SCHOOL DASHBOARD</h2>
                    <p>You can click a name here to jump to a teacher's observation history page.</p>
                    <p>You can also access it from the "Teachers" tab above.</p>`,
                tooltipClass: 'hide-skip'
            },
            {
                element: '#need-help',
                intro: `${ onboardingHelper().closeIconText('doneAdminSchoolDashOnboarding') }
                    <h2>SCHOOL DASHBOARD</h2>
                    <p>If you ever need a reminder, find the tutorial for each page in Growth Explorer here.</p>`,
                tooltipClass: 'last-step'
            }
        ],
        caseloadButton: (intro, context) => {
            return {
                tag: 'a',
                innerHTML: 'YES, PLEASE',
                className: 'introjs-button introjs-fullbutton caseload',
                role: 'button',
                onclick: () => {
                    EventBus.$emit('loading')
                    intro.exit()
                    context.$router.push('caseload')
                }
            }
        },
        createElement: (object) => {
            if (!object) object = {}
            const element = document.createElement(object.tag || 'div')
            Object.keys(object).forEach(key => {
                if (key !== 'tag') element[key] = object[key]
            })
            return element
        }
    }
}